/**
 * Remove duplicate entries from array
 *
* @version     1.0.0
 * @param       array
 */
export function arrayUnique(arr) {
	return arr.filter(function (item, index) {
		return arr.indexOf(item) >= index
	})
}

/**
 * Remove duplicate entries from array
 *
* @version     1.0.0
 * @param       array    An array containing all the checkboxes to check
 */
export function isAnyCheckboxChecked(checkboxes) {
	return checkboxes.some((x) => x.checked)
}

/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
export var simulateClick = function (elem) {
	// Create our event (with options)
	const evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window,
	})
	// If cancelled, don't dispatch our event
	const canceled = !elem.dispatchEvent(evt)
}
